/**
 * @generated SignedSource<<563a8c271f26df74e9f3c31c7adc5db3>>
 * @relayHash b4c5e8d8fe0e4cf7e15ddede8b214601
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 50c0ce974af8bdc413c3f60e4d9e3ba911ae7557d0935f2f44379c4bc9411469

import type { ConcreteRequest, Query } from 'relay-runtime';
export type ContentStateRestrictionLevel = "NONE" | "PAGE_OWNER" | "%future added value";
export type GraphQLDateFormat = "GLOBAL" | "MILLIS" | "USER" | "USER_FRIENDLY" | "%future added value";
export type EditorContentStateQuery$variables = {
  contentId: string;
  format: GraphQLDateFormat;
  isApprovalsFgOn: boolean;
  isDraft: boolean;
  shouldSkipContentStateLastUpdated: boolean;
};
export type EditorContentStateQuery$data = {
  readonly availableContentStates: {
    readonly customContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
    } | null | undefined> | null | undefined;
    readonly spaceContentStates: ReadonlyArray<{
      readonly color: string;
      readonly id: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined> | null | undefined;
  } | null | undefined;
  readonly singleContent: {
    readonly contentState: {
      readonly color: string;
      readonly id: string | null | undefined;
      readonly isCallerPermitted: boolean | null | undefined;
      readonly lastModifierAaid?: string | null | undefined;
      readonly name: string;
      readonly restrictionLevel: ContentStateRestrictionLevel;
    } | null | undefined;
    readonly contentStateLastUpdated?: {
      readonly value: string;
    } | null | undefined;
    readonly id: string | null | undefined;
  } | null | undefined;
};
export type EditorContentStateQuery = {
  response: EditorContentStateQuery$data;
  variables: EditorContentStateQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "contentId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "format"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isApprovalsFgOn"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isDraft"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "shouldSkipContentStateLastUpdated"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
},
v6 = {
  "kind": "Variable",
  "name": "isDraft",
  "variableName": "isDraft"
},
v7 = {
  "kind": "ScalarField",
  "name": "name"
},
v8 = {
  "kind": "ScalarField",
  "name": "color"
},
v9 = {
  "kind": "ScalarField",
  "name": "restrictionLevel"
},
v10 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      (v5/*: any*/),
      {
        "args": [
          (v6/*: any*/)
        ],
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "contentState",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          (v7/*: any*/),
          (v8/*: any*/),
          (v9/*: any*/),
          {
            "kind": "ScalarField",
            "name": "isCallerPermitted"
          },
          {
            "condition": "isApprovalsFgOn",
            "kind": "Condition",
            "passingValue": true,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "lastModifierAaid"
              }
            ]
          }
        ]
      },
      {
        "condition": "shouldSkipContentStateLastUpdated",
        "kind": "Condition",
        "passingValue": false,
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "format",
                "variableName": "format"
              },
              (v6/*: any*/)
            ],
            "concreteType": "ConfluenceDate",
            "kind": "LinkedField",
            "name": "contentStateLastUpdated",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "value"
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "args": [
      {
        "kind": "Variable",
        "name": "contentId",
        "variableName": "contentId"
      }
    ],
    "concreteType": "AvailableContentStates",
    "kind": "LinkedField",
    "name": "availableContentStates",
    "plural": false,
    "selections": [
      {
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "customContentStates",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v5/*: any*/)
        ]
      },
      {
        "concreteType": "ContentState",
        "kind": "LinkedField",
        "name": "spaceContentStates",
        "plural": true,
        "selections": [
          (v7/*: any*/),
          (v8/*: any*/),
          (v5/*: any*/),
          (v9/*: any*/)
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "EditorContentStateQuery",
    "selections": (v10/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "EditorContentStateQuery",
    "selections": (v10/*: any*/)
  },
  "params": {
    "cacheID": "b4c5e8d8fe0e4cf7e15ddede8b214601",
    "id": "50c0ce974af8bdc413c3f60e4d9e3ba911ae7557d0935f2f44379c4bc9411469",
    "metadata": {},
    "name": "EditorContentStateQuery",
    "operationKind": "query",
    "text": "query EditorContentStateQuery($contentId:ID!,$isDraft:Boolean!,$isApprovalsFgOn:Boolean!,$format:GraphQLDateFormat!,$shouldSkipContentStateLastUpdated:Boolean!){singleContent(id:$contentId){id,contentState(isDraft:$isDraft){id,name,color,restrictionLevel,isCallerPermitted,lastModifierAaid@include(if:$isApprovalsFgOn)},contentStateLastUpdated(format:$format,isDraft:$isDraft)@skip(if:$shouldSkipContentStateLastUpdated){value}},availableContentStates(contentId:$contentId){customContentStates{name,color,id},spaceContentStates{name,color,id,restrictionLevel}}}"
  }
};
})();

(node as any).hash = "2ad6563c393bf2c4924f755b12809ec0";

export default node;
